"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _tuner = _interopRequireDefault(require("./tuner"));
var _nowPlayingPoller = _interopRequireDefault(require("./nowPlayingPoller"));
var _idle = _interopRequireDefault(require("./states/idle"));
var _loading = _interopRequireDefault(require("./states/loading"));
var _loaded = _interopRequireDefault(require("./states/loaded"));
var _connecting = _interopRequireDefault(require("./states/connecting"));
var _playing = _interopRequireDefault(require("./states/playing"));
var _paused = _interopRequireDefault(require("./states/paused"));
var _stopped = _interopRequireDefault(require("./states/stopped"));
var _waiting = _interopRequireDefault(require("./states/waiting"));
var _failed = _interopRequireDefault(require("./states/failed"));
_tuner["default"].states = {
  idle: _idle["default"],
  loading: _loading["default"],
  loaded: _loaded["default"],
  connecting: _connecting["default"],
  playing: _playing["default"],
  paused: _paused["default"],
  stopped: _stopped["default"],
  waiting: _waiting["default"],
  failed: _failed["default"]
};
_tuner["default"].state = _tuner["default"].states.idle;
_tuner["default"].fetchCurrentNowPlaying = function (guideId) {
  return _nowPlayingPoller["default"].fetchCurrentNowPlaying(guideId);
};
var _default = exports["default"] = _tuner["default"];
//# sourceMappingURL=index.js.map